import useapp_avif from '_assets/img/onboard/useapp.avif';
import useapp_png from '_assets/img/onboard/useapp.png';
import { isNativeAppEolReached } from '_constants/nativeAppEol';
import { createBackgroundImage } from '_utils/backgroundImage';
import CloseButton from 'Components/CloseButton';
import useNavigate from 'Hooks/useNavigate';
import ImageQuestionScreen from 'Pages/Guest/Onboarding/QuestionScreens/Image/ImageQuestionScreen';
import './UseApp.scss';

const IOS_APP_STORE_URL = 'itms-apps://apps.apple.com/app/id1634163608';
const IOS_APP_STORE_FALLBACK_URL =
    'https://apps.apple.com/us/app/knitandnote-knitting-app/id1634163608';
const ANDROID_PLAY_STORE_URL =
    'https://play.google.com/store/apps/details?id=com.knitandnote.android';

const getStoreUrlByAgent = (userAgent: string): string => {
    if (/iphone|ipad|ipod/i.test(userAgent)) {
        return IOS_APP_STORE_URL;
    }

    if (/android/i.test(userAgent)) {
        return ANDROID_PLAY_STORE_URL;
    }

    return IOS_APP_STORE_FALLBACK_URL;
};

const openStoreForPlatform = (): void => {
    const userAgent =
        typeof navigator === 'undefined'
            ? ''
            : (navigator.userAgent ?? navigator.vendor ?? '');
    const targetUrl = getStoreUrlByAgent(userAgent);

    if (typeof window !== 'undefined' && typeof window.open === 'function') {
        window.open(targetUrl, '_blank', 'noopener,noreferrer');
        return;
    }

    if (typeof globalThis !== 'undefined' && globalThis.location) {
        globalThis.location.href = targetUrl;
    }
};

const UseAppPage = (): React.JSX.Element => {
    const navigate = useNavigate();

    // Url has ?showx
    const isFromLogin =
        typeof window !== 'undefined' &&
        new URLSearchParams(window.location.search).has('showx');

    return (
        <div className="use-app-screen">
            {/* From the EOL date the app is the only way in — no closing
                this screen, not even on the login path. */}
            {isFromLogin && !isNativeAppEolReached() && (
                <CloseButton onClose={() => navigate('/login')} />
            )}
            <ImageQuestionScreen
                question={{
                    type: 'image',
                    text: {
                        en: isFromLogin
                            ? '<b>Welcome back 🤎</b><br/>Continue in the app for the best experience 🤗'
                            : '<b>Welcome 🤎</b><br/>Continue in the app, where everything is ready for you 🤗',
                        no: isFromLogin
                            ? '<b>Velkommen tilbake 🤎</b><br/>Fortsett i appen for den beste opplevelsen 🤗'
                            : '<b>Velkommen 🤎</b><br/>Fortsett i appen, der alt ligger klart for deg 🤗',
                    },
                    id: 'USE_APP',
                    backgroundImage: createBackgroundImage(
                        useapp_avif,
                        useapp_png,
                    ),
                    buttonText: {
                        no: 'Last ned appen',
                        en: 'Download app',
                    },
                    nextQuestion: () => {
                        return 'USE_APP';
                    },
                }}
                onAnswer={openStoreForPlatform}
                isReboarding={false}
            />
        </div>
    );
};

export default UseAppPage;
